import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApplicationState {
  isEdited: boolean; // used to show cancelModal/ form state
  saveOK: boolean; // used to show succes message
  redirectURL?: string; // used to navigate to dedicated page
}

const initialState: ApplicationState = {
  isEdited: false,
  saveOK: false,
};

const applicationSlice = createSlice({
  name: "application",
  initialState: initialState,
  reducers: {
    setIsEdited(state) {
      return {
        ...state,
        isEdited: true,
      };
    },
    resetIsEdited(state) {
      return {
        ...state,
        isEdited: false,
      };
    },
    setSaveOK(state) {
      return {
        ...state,
        saveOK: true,
      };
    },
    resetSaveOK(state) {
      return {
        ...state,
        saveOK: false,
      };
    },
    setRedirectURL(state, action: PayloadAction<string>) {
      return {
        ...state,
        redirectURL: action.payload,
      };
    },
    resetRedirectURL(state) {
      return {
        ...state,
        redirectURL: undefined,
      };
    },
  },
});

export const {
  setIsEdited,
  resetIsEdited,
  setSaveOK,
  resetSaveOK,
  setRedirectURL,
  resetRedirectURL,
} = applicationSlice.actions;
export default applicationSlice.reducer;
